import { render, staticRenderFns } from "./ResultTableSettings.vue?vue&type=template&id=d19004c6&"
import script from "./ResultTableSettings.vue?vue&type=script&lang=js&"
export * from "./ResultTableSettings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/normacs_web/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports